import React, { useState, useEffect } from 'react'
import { useForm } from "react-hook-form";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { getOnlyToken } from './../../utils/commonFunctions';
import Header from '../../common/Header';
import Sidebar from '../../common/Sidebar';

export default function CreateIntegration() {
    const navigate = useNavigate();
    const location = useLocation();
    const editId = location.state?.editId || null;
    const isEdit = !!editId;

    const { register, handleSubmit, formState: { errors }, setValue } = useForm();

    const [requestParams, setrequestParams] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [errorForParams, seterrorForParams] = useState("");
    const [errorForHeaders, seterrorForHeaders] = useState("");
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(false);
    const [fetchedData, setFetchedData] = useState(null);

    const fetchFunctionById = async (id) => {
        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };
        setFetching(true);
        try {
            const res = await axios.get(`/api/agents/custom-functions/create/?id=${id}`, config);
            if (res.status === 200 && res.data.data && res.data.data.length > 0) {
                const data = res.data.data[0];
                setFetchedData(data);

                if (data.parameters && data.parameters.length > 0) {
                    setrequestParams(data.parameters.map(p => ({
                        name: p.name || "",
                        type: p.type || "",
                        description: p.description || "",
                        required: p.required || false,
                    })));
                }

                if (data.headers && typeof data.headers === 'object' && Object.keys(data.headers).length > 0) {
                    const headerArray = Object.entries(data.headers).map(([key, value]) => ({ key, value }));
                    setHeaders(headerArray);
                }
            }
        } catch (error) {
            console.error("Error fetching custom function:", error);
        } finally {
            setFetching(false);
        }
    };

    useEffect(() => {
        if (editId) {
            fetchFunctionById(editId);
        }
    }, [editId]);

    useEffect(() => {
        if (fetchedData && !fetching) {
            setValue("function_name", fetchedData.function_name);
            setValue("url", fetchedData.url);
            setValue("url_type", fetchedData.url_type);
            setValue("data_type", fetchedData.data_type);
            setValue("function_description", fetchedData.function_description);
        }
    }, [fetchedData, fetching, setValue]);

    const onSubmit = async (data) => {
        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };

        let paramErrors = 0;
        requestParams.forEach((params) => {
            if (!params.name || !params.description || !params.type) {
                paramErrors++;
            }
        });

        if (paramErrors !== 0) {
            seterrorForParams("Please enter all details in params");
            return false;
        }

        let headerErrors = 0;
        headers.forEach((header) => {
            if (!header.key || !header.value) {
                headerErrors++;
            }
        });

        if (headerErrors !== 0) {
            seterrorForHeaders("Please enter both key and value for all headers");
            return false;
        }

        data.parameters = requestParams;

        const headersObj = {};
        headers.forEach(header => {
            headersObj[header.key] = header.value;
        });
        data.headers = headersObj;

        setLoading(true);
        try {
            if (isEdit) {
                const res = await axios.put(`/api/agents/custom-functions/create/?id=${editId}`, data, config);
                if (res.data) {
                    navigate('/integrations');
                }
            } else {
                const res = await axios.post(`/api/agents/custom-functions/create/`, data, config);
                if (res.data) {
                    navigate('/integrations');
                }
            }
        } catch (error) {
            console.error(isEdit ? "Error updating custom function:" : "Error creating custom function:", error);
        } finally {
            setLoading(false);
        }
    };

    const AddNewParamsToDist = () => {
        let requestParam = requestParams;
        let object = { name: "", type: "", description: "" };
        requestParam.push(object);
        setrequestParams([...requestParam]);
    };

    const AddNewHeader = () => {
        let headerList = headers;
        let object = { key: "", value: "" };
        headerList.push(object);
        setHeaders([...headerList]);
    };

    const removeRequestParam = (index) => {
        const params = [...requestParams];
        if (index >= 0 && index < params.length) {
            params.splice(index, 1);
            setrequestParams(params);
        }
    };

    const removeHeader = (index) => {
        const headerList = [...headers];
        if (index >= 0 && index < headerList.length) {
            headerList.splice(index, 1);
            setHeaders(headerList);
        }
    };

    const changeParameterNameandLabel = (value, number, type) => {
        seterrorForParams("");
        let requestParam = requestParams;
        if (type === "name") {
            requestParam[number].name = value;
        }
        if (type === "type") {
            requestParam[number].type = value;
        }
        if (type === "description") {
            requestParam[number].description = value;
        }
        if (type === "required") {
            requestParam[number].required = value;
        }
        setrequestParams([...requestParam]);
    };

    const changeHeaderKeyValue = (value, number, type) => {
        seterrorForHeaders("");
        let headerList = headers;
        if (type === "key") {
            headerList[number].key = value;
        }
        if (type === "value") {
            headerList[number].value = value;
        }
        setHeaders([...headerList]);
    };

    return (
        <div id='layout-wrapper'>
            <Header />
            <Sidebar />
            <div className='page-content'>

                <div className="main-content">
                    <div className="container-fluid py-4">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h2 className="fw-bold  mb-0">
                                {isEdit ? "Edit Custom Function" : "Add Custom Function"}
                            </h2>
                        </div>

                        <div className="card p-4">
                            {fetching ? (
                                <div className="d-flex justify-content-center py-5">
                                    <div className="spinner-border text-success" role="status"></div>
                                </div>
                            ) : <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row g-2 mb-1">
                                    <div className="mb-1 col-md-4">
                                        <label className="form-label">
                                            Function Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.function_name ? "is-invalid" : ""}`}
                                            placeholder="Enter Function Name"
                                            {...register("function_name", {
                                                required: "Function Name is required",
                                                pattern: {
                                                    value: /^[A-Za-z_]+$/,
                                                    message: "Function Name must contain only alphabets and underscores",
                                                },
                                                minLength: { value: 2, message: "Function Name must be at least 2 characters" },
                                            })}
                                        />
                                        {errors.function_name && (
                                            <div className="invalid-feedback">{errors.function_name.message}</div>
                                        )}
                                    </div>

                                    <div className="mb-1 col-md-4">
                                        <label className="form-label">
                                            API URL <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.url ? "is-invalid" : ""}`}
                                            placeholder="Enter API URL"
                                            {...register("url", {
                                                required: "API URL is required",
                                                pattern: {
                                                    value: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/,
                                                    message: "Enter a valid website URL",
                                                }
                                            })}
                                        />
                                        {errors.url && (
                                            <div className="invalid-feedback">{errors.url.message}</div>
                                        )}
                                    </div>

                                    <div className="mb-1 col-md-4">
                                        <label className="form-label">
                                            URL Type <span className="text-danger">*</span>
                                        </label>
                                        <select className={`form-control ${errors.url_type ? "is-invalid" : ""}`} defaultValue=""
                                            {...register("url_type", {
                                                required: "URL Type is required",
                                            })}>
                                            <option value="">Choose URL Type</option>
                                            <option value="POST">POST</option>
                                            <option value="GET">GET</option>
                                            <option value="PATCH">PATCH</option>
                                            <option value="PUT">PUT</option>
                                            <option value="DELETE">DELETE</option>
                                        </select>
                                        {errors.url_type && (
                                            <div className="invalid-feedback">{errors.url_type.message}</div>
                                        )}
                                    </div>

                                    <div className="mb-1 col-md-4">
                                        <label className="form-label fw-medium">
                                            Data Type <span className="text-danger">*</span>
                                        </label>
                                        <div className='d-flex gap-2'>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="data_type"
                                                    id="formData"
                                                    value="form-data"
                                                    {...register("data_type", {
                                                        required: "Data Type is required",
                                                    })}
                                                />
                                                <label className="form-check-label" htmlFor="formData">
                                                    Form Data
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="data_type"
                                                    id="rawData"
                                                    value="raw"
                                                    {...register("data_type")}
                                                />
                                                <label className="form-check-label" htmlFor="rawData">
                                                    Raw Data
                                                </label>
                                            </div>
                                        </div>
                                        {errors.data_type && (
                                            <div className="text-danger small mt-1">
                                                {errors.data_type.message}
                                            </div>
                                        )}
                                    </div>

                                    <div className="mb-1 col-md-8">
                                        <label className="form-label">
                                            Description <span className="text-danger">*</span>
                                        </label>
                                        <textarea
                                            rows={3}
                                            className={`form-control ${errors.function_description ? "is-invalid" : ""}`}
                                            placeholder="Enter Description"
                                            {...register("function_description", {
                                                required: "Description is required",
                                            })}
                                        />
                                        {errors.function_description && (
                                            <div className="invalid-feedback">{errors.function_description.message}</div>
                                        )}
                                    </div>

                                    <div>
                                        <p className="fw-medium">Request Parameters</p>
                                    </div>
                                    <div className='card p-2 shadow-none border '>
                                        {requestParams.length === 0 ? (
                                            <p className="text-muted text-center fs-5 my-2">No parameters added yet. Click "Add" to add request parameters.</p>
                                        ) : (
                                            <div className='row'>
                                                {requestParams.map((params, i) => (
                                                    <React.Fragment key={i}>
                                                        <div className='col-md-4 mb-2'>
                                                            <label className="form-label">
                                                                Parameter Name <span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className={`form-control ${errorForParams && !params.name ? "is-invalid" : ""}`}
                                                                placeholder="Enter Parameter Name"
                                                                value={params.name}
                                                                onChange={(e) => changeParameterNameandLabel(e.target.value, i, 'name')}
                                                            />
                                                        </div>
                                                        <div className='col-md-3 mb-2'>
                                                            <label className="form-label">
                                                                Data Type <span className="text-danger">*</span>
                                                            </label>
                                                            <select className={`form-select ${errorForParams && !params.type ? "is-invalid" : ""}`} value={params.type} onChange={(e) => changeParameterNameandLabel(e.target.value, i, 'type')}>
                                                                <option value="">Choose Type</option>
                                                                <option value="String">String</option>
                                                                <option value="Number">Number</option>
                                                                <option value="Array">Array</option>
                                                                <option value="Object">Object</option>
                                                                <option value="Boolean">Boolean</option>
                                                            </select>
                                                        </div>
                                                        <div className='col-md-3 mb-2'>
                                                            <label className="form-label">
                                                                Description <span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className={`form-control ${errorForParams && !params.description ? "is-invalid" : ""}`}
                                                                placeholder="Enter Description"
                                                                value={params.description}
                                                                onChange={(e) => changeParameterNameandLabel(e.target.value, i, 'description')}
                                                            />
                                                        </div>
                                                        <div className='col-md-1 d-flex flex-column align-items-center'>
                                                            <label className="form-label">Required</label>
                                                            <input type='checkbox' className='form-check-input mt-2' checked={params.required} onChange={(e) => changeParameterNameandLabel(e.target.checked, i, 'required')} />
                                                        </div>
                                                        <div className='col-md-1 mb-2'>
                                                            <span className="btn btn-link fs-16 p-1 text-danger mt-3" onClick={() => removeRequestParam(i)}>
                                                                <i className="bi bi-trash"></i>
                                                            </span>
                                                        </div>
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        )}
                                        {errorForParams && <div className='text-danger small mt-1 ms-1'>{errorForParams}</div>}
                                        <div className='col-md-12'>
                                            <div className='mt-2 text-end' id='msform'>
                                                <button className="btn btn-sm btn-primary" type="button" onClick={() => AddNewParamsToDist()}>
                                                    <i className="bi bi-plus-lg me-1"></i>Add
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <p className="fw-medium">Headers</p>
                                    </div>
                                    <div className='card p-2 shadow-none border '>
                                        {headers.length === 0 ? (
                                            <p className="text-muted text-center fs-5 my-2">No headers added yet. Click "Add Header" to add custom headers.</p>
                                        ) : (
                                            <div className='row'>
                                                {headers.map((header, i) => (
                                                    <React.Fragment key={i}>
                                                        <div className='col-md-5 mb-2'>
                                                            <label className="form-label">
                                                                Header Key <span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className={`form-control ${errorForHeaders && !header.key ? "is-invalid" : ""}`}
                                                                placeholder="e.g., X-API-Key"
                                                                value={header.key}
                                                                onChange={(e) => changeHeaderKeyValue(e.target.value, i, 'key')}
                                                            />
                                                        </div>
                                                        <div className='col-md-6 mb-2'>
                                                            <label className="form-label">
                                                                Header Value <span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className={`form-control ${errorForHeaders && !header.value ? "is-invalid" : ""}`}
                                                                placeholder="Enter Header Value"
                                                                value={header.value}
                                                                onChange={(e) => changeHeaderKeyValue(e.target.value, i, 'value')}
                                                            />
                                                        </div>
                                                        <div className='col-md-1 mb-2'>
                                                            <label className="form-label">&nbsp;</label>
                                                            <span className="btn btn-link fs-16 p-1 text-danger d-block" onClick={() => removeHeader(i)}>
                                                                <i className="bi bi-trash"></i>
                                                            </span>
                                                        </div>
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        )}
                                        {errorForHeaders && <div className='text-danger small mt-1 ms-1'>{errorForHeaders}</div>}
                                        <div className='col-md-12'>
                                            <div className='mt-2 text-end' id='msform'>
                                                <button className="btn btn-sm btn-primary" type="button" onClick={() => AddNewHeader()}>
                                                    <i className="bi bi-plus-lg me-1"></i>Add Header
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-end gap-2 mt-3">
                                    <button className="btn btn-md btn-secondary" type="button" disabled={loading}
                                        onClick={() => navigate('/integrations')}>
                                        Cancel
                                    </button>
                                    <button className="btn btn-md btn-primary" type="submit" disabled={loading}>
                                        {loading && <span className="spinner-border spinner-border-sm me-1" role="status"></span>}
                                        {isEdit ? "Update Function" : "Add Function"}
                                    </button>
                                </div>
                            </form>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
